import { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

import { request } from "utils/request";
import useStore from "hooks/useStore";

interface SubmitButtonProps {
  disabled: boolean;
}

interface Props {
  campId: string;
}

const WriteComment = ({ campId }: Props) => {
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const { toggleLoginModal, user } = useStore();

  const ProfileIconSrc = user?.facebookId
    ? `https://graph.facebook.com/${user.facebookId}/picture?type=normal`
    : user?.profilePicture || "/images/profile.png";

  const onChangeHandler = (e: any) => {
    setComment(e.target.value);
  };

  const sendComment = async () => {
    try {
      setLoading(true);
      const postData = {
        userFullName: user?.fullName,
        comment: comment,
        campId: campId,
      };

      const { data } = await request("comment", "POST", postData);
      setLoading(false);
      if (data.status) {
        setComment("");
        toast.success(
          "Mesajınız başarılı bir şekilde yollanmıştır. En kısa sürede onay sürecinden geçip eklenecektir.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      } else {
        toast.error("Bir hata oluştu. Lütfen tekrar deneyin.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (err) {
      toast.error("Bir hata oluştu. Lütfen tekrar deneyin.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  return (
    <Container>
      <CommentContainer>
        <UserContainer>
          {user.id ? (
            <ProfileIcon
              hasBorder={false}
              src={ProfileIconSrc}
              width={20}
              height={20}
              alt="profile_image"
            />
          ) : (
            <UserIcon icon={faUser} />
          )}
        </UserContainer>
        <>
          {user.id && (
            <Input
              value={comment}
              placeholder={"Bir şeyler yaz..."}
              rows={3}
              onChange={onChangeHandler}
            />
          )}
          {!user.id && (
            <LoginText onClick={toggleLoginModal}>
              Yorum yapabilmek için lütfen giriş yapın.
            </LoginText>
          )}
        </>
      </CommentContainer>
      {user.id && (
        <SubmitButton disabled={comment === "" || loading} onClick={sendComment}>
          Gönder
        </SubmitButton>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const CommentContainer = styled.div`
  width: 100%;
  margin-top: 32px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const UserContainer = styled.div`
  padding: 8px 10px;
  border: 1px solid #dddddd;
  border-radius: 50px;
  background-color: white;
  svg {
    color: #666666;
  }
`;

const UserIcon = styled(FontAwesomeIcon)`
  width: 20px;
  height: 20px;
`;

const Input = styled.textarea`
  width: 100%;
  font-family: "Open Sans", sans-serif;
  background-color: #f0f2f5;
  border-width: 0px;
  border-radius: 6px;
  margin-left: 12px;
  padding: 12px;
`;

const SubmitButton = styled.button<SubmitButtonProps>`
  cursor: pointer;
  display: inline-block;
  position: relative;
  text-align: center;
  text-decoration: none;
  touch-action: manipulation;
  font-family: Circular, -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  border-radius: 4px;
  outline: none;
  padding: 14px 24px;
  margin: 24px 0px 0px;
  transition: box-shadow 0.2s ease 0s, -ms-transform 0.1s ease 0s, -webkit-transform 0.1s ease 0s, transform 0.1s ease 0s;
  -webkit-tap-highlight-color: transparent;
  border: none;
  background: ${(props) => (props.disabled ? "gray" : "#ee7b21")};

  color: rgb(255, 255, 255);
  width: 200px;
  @media (max-width: ${(props) => props.theme.size.tablet}) {
    width: 100%;
  }
}
`;

const ProfileIcon = styled.img<{ hasBorder: boolean }>`
  width: 40px;
  height: 40px;
  object-fit: contain;
  overflow: hidden;
  border-radius: 50px;
`;

const LoginText = styled.span`
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  border-radius: 8px;
  outline: none;
  padding: 8px;
  transition: box-shadow 0.2s ease 0s, -ms-transform 0.1s ease 0s,
    -webkit-transform 0.1s ease 0s, transform 0.1s ease 0s;
  border: none;
  color: rgb(34, 34, 34);
  text-decoration: underline;
  cursor: pointer;
  margin-left: 12px;
`;

export default WriteComment;
